import { Controller } from '@hotwired/stimulus';

/*
 * Autocomplete widget for the product search form.
 * Attach with data-controller="product-search" (see product/search_form.html.twig).
 */
export default class extends Controller {
    static targets = ['input', 'results'];
    static values = { url: String };

    connect() {
        this.timeout = null;
        this.abortController = null;
        this.boundHandleClickOutside = this.handleClickOutside.bind(this);
        document.addEventListener('click', this.boundHandleClickOutside);
    }

    disconnect() {
        document.removeEventListener('click', this.boundHandleClickOutside);
        clearTimeout(this.timeout);
        if (this.abortController) {
            this.abortController.abort();
        }
    }

    handleClickOutside(event) {
        if (!this.element.contains(event.target)) {
            this.hideResults();
        }
    }

    search() {
        const query = this.inputTarget.value.trim();

        clearTimeout(this.timeout);

        if (query.length < 2) {
            this.hideResults();
            return;
        }

        this.timeout = setTimeout(() => this.fetchResults(query), 300);
    }

    fetchResults(query) {
        if (this.abortController) {
            this.abortController.abort();
        }
        this.abortController = new AbortController();

        fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`, { signal: this.abortController.signal })
            .then((response) => response.json())
            .then((products) => this.renderResults(products))
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    this.hideResults();
                }
            });
    }

    renderResults(products) {
        this.resultsTarget.innerHTML = '';

        if (products.length === 0) {
            this.hideResults();
            return;
        }

        products.forEach((product) => {
            const li = document.createElement('li');
            const link = document.createElement('a');
            link.href = product.url;

            if (product.image) {
                const image = document.createElement('img');
                image.src = product.image;
                image.alt = '';
                image.loading = 'lazy';
                image.className = 'product-search-results-image';
                link.appendChild(image);
            }

            const label = document.createElement('span');
            label.textContent = product.size ? `${product.name} (${product.size})` : product.name;
            link.appendChild(label);

            li.appendChild(link);
            this.resultsTarget.appendChild(li);
        });

        this.resultsTarget.hidden = false;
    }

    hideResults() {
        this.resultsTarget.hidden = true;
        this.resultsTarget.innerHTML = '';
    }

    clear() {
        this.inputTarget.value = '';
        this.hideResults();
    }
}
